/**
 * Resource-type → base-type table, derived from Godot 4.6.3.stable.fedora.7d41c59c4's ClassDB.
 * AUTO-GENERATED - Do not edit manually. Run: pnpm nodes:base-types
 *
 * Every Resource class, instantiable or not and property-declaring or not:
 * `StandardMaterial3D` declares nothing and `BaseMaterial3D`, which declares
 * the material properties, is abstract, so a table filtered on either would
 * break the one chain a scene names. `Resource` is the terminal and has no
 * entry. ValidatorRegistry.ts merges it with the node table to build the walk.
 */
export const RESOURCE_BASE_TYPES_GENERATED = Object.freeze({
    AnimatedTexture: 'Texture2D',
    Animation: 'Resource',
    AnimationLibrary: 'Resource',
    AnimationNode: 'Resource',
    AnimationNodeAdd2: 'AnimationNodeSync',
    AnimationNodeAdd3: 'AnimationNodeSync',
    AnimationNodeAnimation: 'AnimationRootNode',
    AnimationNodeBlend2: 'AnimationNodeSync',
    AnimationNodeBlend3: 'AnimationNodeSync',
    AnimationNodeBlendSpace1D: 'AnimationRootNode',
    AnimationNodeBlendSpace2D: 'AnimationRootNode',
    AnimationNodeBlendTree: 'AnimationRootNode',
    AnimationNodeExtension: 'AnimationNode',
    AnimationNodeOneShot: 'AnimationNodeSync',
    AnimationNodeOutput: 'AnimationNode',
    AnimationNodeStateMachine: 'AnimationRootNode',
    AnimationNodeStateMachinePlayback: 'Resource',
    AnimationNodeStateMachineTransition: 'Resource',
    AnimationNodeSub2: 'AnimationNodeSync',
    AnimationNodeSync: 'AnimationNode',
    AnimationNodeTimeScale: 'AnimationNode',
    AnimationNodeTimeSeek: 'AnimationNode',
    AnimationNodeTransition: 'AnimationNodeSync',
    AnimationRootNode: 'AnimationNode',
    ArrayMesh: 'Mesh',
    ArrayOccluder3D: 'Occluder3D',
    AtlasTexture: 'Texture2D',
    AudioBusLayout: 'Resource',
    AudioEffect: 'Resource',
    AudioEffectAmplify: 'AudioEffect',
    AudioEffectBandLimitFilter: 'AudioEffectFilter',
    AudioEffectBandPassFilter: 'AudioEffectFilter',
    AudioEffectCapture: 'AudioEffect',
    AudioEffectChorus: 'AudioEffect',
    AudioEffectCompressor: 'AudioEffect',
    AudioEffectDelay: 'AudioEffect',
    AudioEffectDistortion: 'AudioEffect',
    AudioEffectEQ: 'AudioEffect',
    AudioEffectEQ10: 'AudioEffectEQ',
    AudioEffectEQ21: 'AudioEffectEQ',
    AudioEffectEQ6: 'AudioEffectEQ',
    AudioEffectFilter: 'AudioEffect',
    AudioEffectHardLimiter: 'AudioEffect',
    AudioEffectHighPassFilter: 'AudioEffectFilter',
    AudioEffectHighShelfFilter: 'AudioEffectFilter',
    AudioEffectLimiter: 'AudioEffect',
    AudioEffectLowPassFilter: 'AudioEffectFilter',
    AudioEffectLowShelfFilter: 'AudioEffectFilter',
    AudioEffectNotchFilter: 'AudioEffectFilter',
    AudioEffectPanner: 'AudioEffect',
    AudioEffectPhaser: 'AudioEffect',
    AudioEffectPitchShift: 'AudioEffect',
    AudioEffectRecord: 'AudioEffect',
    AudioEffectReverb: 'AudioEffect',
    AudioEffectSpectrumAnalyzer: 'AudioEffect',
    AudioEffectStereoEnhance: 'AudioEffect',
    AudioStream: 'Resource',
    AudioStreamGenerator: 'AudioStream',
    AudioStreamInteractive: 'AudioStream',
    AudioStreamMicrophone: 'AudioStream',
    AudioStreamMP3: 'AudioStream',
    AudioStreamOggVorbis: 'AudioStream',
    AudioStreamPlaylist: 'AudioStream',
    AudioStreamPolyphonic: 'AudioStream',
    AudioStreamRandomizer: 'AudioStream',
    AudioStreamSynchronized: 'AudioStream',
    AudioStreamWAV: 'AudioStream',
    BaseMaterial3D: 'Material',
    BitMap: 'Resource',
    BoneMap: 'Resource',
    BoxMesh: 'PrimitiveMesh',
    BoxOccluder3D: 'Occluder3D',
    BoxShape3D: 'Shape3D',
    ButtonGroup: 'Resource',
    CameraAttributes: 'Resource',
    CameraAttributesPhysical: 'CameraAttributes',
    CameraAttributesPractical: 'CameraAttributes',
    CameraTexture: 'Texture2D',
    CanvasItemMaterial: 'Material',
    CanvasTexture: 'Texture2D',
    CapsuleMesh: 'PrimitiveMesh',
    CapsuleShape2D: 'Shape2D',
    CapsuleShape3D: 'Shape3D',
    CircleShape2D: 'Shape2D',
    CodeHighlighter: 'SyntaxHighlighter',
    ColorPalette: 'Resource',
    Compositor: 'Resource',
    CompositorEffect: 'Resource',
    CompressedCubemap: 'CompressedTextureLayered',
    CompressedCubemapArray: 'CompressedTextureLayered',
    CompressedTexture2D: 'Texture2D',
    CompressedTexture2DArray: 'CompressedTextureLayered',
    CompressedTexture3D: 'Texture3D',
    CompressedTextureLayered: 'TextureLayered',
    ConcavePolygonShape2D: 'Shape2D',
    ConcavePolygonShape3D: 'Shape3D',
    ConvexPolygonShape2D: 'Shape2D',
    ConvexPolygonShape3D: 'Shape3D',
    CryptoKey: 'Resource',
    Cubemap: 'ImageTextureLayered',
    CubemapArray: 'ImageTextureLayered',
    Curve: 'Resource',
    Curve2D: 'Resource',
    Curve3D: 'Resource',
    CurveTexture: 'Texture2D',
    CurveXYZTexture: 'Texture2D',
    CylinderMesh: 'PrimitiveMesh',
    CylinderShape3D: 'Shape3D',
    DPITexture: 'Texture2D',
    EditorNode3DGizmoPlugin: 'Resource',
    EditorSettings: 'Resource',
    EditorSyntaxHighlighter: 'SyntaxHighlighter',
    Environment: 'Resource',
    ExternalTexture: 'Texture2D',
    FastNoiseLite: 'Noise',
    FBXDocument: 'GLTFDocument',
    FBXState: 'GLTFState',
    FogMaterial: 'Material',
    FoldableGroup: 'Resource',
    Font: 'Resource',
    FontFile: 'Font',
    FontVariation: 'Font',
    GDExtension: 'Resource',
    GDScript: 'Script',
    GDScriptSyntaxHighlighter: 'EditorSyntaxHighlighter',
    GLTFAccessor: 'Resource',
    GLTFAnimation: 'Resource',
    GLTFBufferView: 'Resource',
    GLTFCamera: 'Resource',
    GLTFDocument: 'Resource',
    GLTFDocumentExtension: 'Resource',
    GLTFDocumentExtensionConvertImporterMesh: 'GLTFDocumentExtension',
    GLTFDocumentExtensionPhysics: 'GLTFDocumentExtension',
    GLTFDocumentExtensionTextureKTX: 'GLTFDocumentExtension',
    GLTFDocumentExtensionTextureWebP: 'GLTFDocumentExtension',
    GLTFLight: 'Resource',
    GLTFMesh: 'Resource',
    GLTFNode: 'Resource',
    GLTFPhysicsBody: 'Resource',
    GLTFPhysicsShape: 'Resource',
    GLTFSkeleton: 'Resource',
    GLTFSkin: 'Resource',
    GLTFSpecGloss: 'Resource',
    GLTFState: 'Resource',
    GLTFTexture: 'Resource',
    GLTFTextureSampler: 'Resource',
    Gradient: 'Resource',
    GradientTexture1D: 'Texture2D',
    GradientTexture2D: 'Texture2D',
    HeightMapShape3D: 'Shape3D',
    Image: 'Resource',
    ImageTexture: 'Texture2D',
    ImageTexture3D: 'Texture3D',
    ImageTextureLayered: 'TextureLayered',
    ImmediateMesh: 'Mesh',
    ImporterMesh: 'Resource',
    InputEvent: 'Resource',
    InputEventAction: 'InputEvent',
    InputEventFromWindow: 'InputEvent',
    InputEventGesture: 'InputEventWithModifiers',
    InputEventJoypadButton: 'InputEvent',
    InputEventJoypadMotion: 'InputEvent',
    InputEventKey: 'InputEventWithModifiers',
    InputEventMagnifyGesture: 'InputEventGesture',
    InputEventMIDI: 'InputEvent',
    InputEventMouse: 'InputEventWithModifiers',
    InputEventMouseButton: 'InputEventMouse',
    InputEventMouseMotion: 'InputEventMouse',
    InputEventPanGesture: 'InputEventGesture',
    InputEventScreenDrag: 'InputEventFromWindow',
    InputEventScreenTouch: 'InputEventFromWindow',
    InputEventShortcut: 'InputEvent',
    InputEventWithModifiers: 'InputEventFromWindow',
    JointLimitation3D: 'Resource',
    JointLimitationCone3D: 'JointLimitation3D',
    JSON: 'Resource',
    LabelSettings: 'Resource',
    LightmapGIData: 'Resource',
    Material: 'Resource',
    Mesh: 'Resource',
    MeshLibrary: 'Resource',
    MeshTexture: 'Texture2D',
    MissingResource: 'Resource',
    MultiMesh: 'Resource',
    NavigationMesh: 'Resource',
    NavigationMeshSourceGeometryData2D: 'Resource',
    NavigationMeshSourceGeometryData3D: 'Resource',
    NavigationPolygon: 'Resource',
    Noise: 'Resource',
    NoiseTexture2D: 'Texture2D',
    NoiseTexture3D: 'Texture3D',
    Occluder3D: 'Resource',
    OccluderPolygon2D: 'Resource',
    OggPacketSequence: 'Resource',
    OpenXRAction: 'Resource',
    OpenXRActionBindingModifier: 'OpenXRBindingModifier',
    OpenXRActionMap: 'Resource',
    OpenXRActionSet: 'Resource',
    OpenXRAnalogThresholdModifier: 'OpenXRActionBindingModifier',
    OpenXRBindingModifier: 'Resource',
    OpenXRDpadBindingModifier: 'OpenXRIPBindingModifier',
    OpenXRHapticBase: 'Resource',
    OpenXRHapticVibration: 'OpenXRHapticBase',
    OpenXRInteractionProfile: 'Resource',
    OpenXRIPBinding: 'Resource',
    OpenXRIPBindingModifier: 'OpenXRBindingModifier',
    OptimizedTranslation: 'Translation',
    ORMMaterial3D: 'BaseMaterial3D',
    PackedDataContainer: 'Resource',
    PackedScene: 'Resource',
    PanoramaSkyMaterial: 'Material',
    ParticleProcessMaterial: 'Material',
    PhysicalSkyMaterial: 'Material',
    PhysicsMaterial: 'Resource',
    PlaceholderCubemap: 'PlaceholderTextureLayered',
    PlaceholderCubemapArray: 'PlaceholderTextureLayered',
    PlaceholderMaterial: 'Material',
    PlaceholderMesh: 'Mesh',
    PlaceholderTexture2D: 'Texture2D',
    PlaceholderTexture2DArray: 'PlaceholderTextureLayered',
    PlaceholderTexture3D: 'Texture3D',
    PlaceholderTextureLayered: 'TextureLayered',
    PlaneMesh: 'PrimitiveMesh',
    PointMesh: 'PrimitiveMesh',
    PolygonOccluder3D: 'Occluder3D',
    PolygonPathFinder: 'Resource',
    PortableCompressedTexture2D: 'Texture2D',
    PrimitiveMesh: 'Mesh',
    PrismMesh: 'PrimitiveMesh',
    ProceduralSkyMaterial: 'Material',
    QuadMesh: 'PlaneMesh',
    QuadOccluder3D: 'Occluder3D',
    RDShaderFile: 'Resource',
    RDShaderSPIRV: 'Resource',
    RectangleShape2D: 'Shape2D',
    RibbonTrailMesh: 'PrimitiveMesh',
    RichTextEffect: 'Resource',
    SceneReplicationConfig: 'Resource',
    Script: 'Resource',
    ScriptExtension: 'Script',
    SegmentShape2D: 'Shape2D',
    SeparationRayShape2D: 'Shape2D',
    SeparationRayShape3D: 'Shape3D',
    Shader: 'Resource',
    ShaderInclude: 'Resource',
    ShaderMaterial: 'Material',
    Shape2D: 'Resource',
    Shape3D: 'Resource',
    Shortcut: 'Resource',
    SkeletonModification2D: 'Resource',
    SkeletonModification2DCCDIK: 'SkeletonModification2D',
    SkeletonModification2DFABRIK: 'SkeletonModification2D',
    SkeletonModification2DJiggle: 'SkeletonModification2D',
    SkeletonModification2DLookAt: 'SkeletonModification2D',
    SkeletonModification2DPhysicalBones: 'SkeletonModification2D',
    SkeletonModification2DStackHolder: 'SkeletonModification2D',
    SkeletonModification2DTwoBoneIK: 'SkeletonModification2D',
    SkeletonModificationStack2D: 'Resource',
    SkeletonProfile: 'Resource',
    SkeletonProfileHumanoid: 'SkeletonProfile',
    Skin: 'Resource',
    Sky: 'Resource',
    SphereMesh: 'PrimitiveMesh',
    SphereOccluder3D: 'Occluder3D',
    SphereShape3D: 'Shape3D',
    SpriteFrames: 'Resource',
    StandardMaterial3D: 'BaseMaterial3D',
    StyleBox: 'Resource',
    StyleBoxEmpty: 'StyleBox',
    StyleBoxFlat: 'StyleBox',
    StyleBoxLine: 'StyleBox',
    StyleBoxTexture: 'StyleBox',
    SyntaxHighlighter: 'Resource',
    SystemFont: 'Font',
    TextMesh: 'PrimitiveMesh',
    Texture: 'Resource',
    Texture2D: 'Texture',
    Texture2DArray: 'ImageTextureLayered',
    Texture2DArrayRD: 'TextureLayeredRD',
    Texture2DRD: 'Texture2D',
    Texture3D: 'Texture',
    Texture3DRD: 'Texture3D',
    TextureCubemapArrayRD: 'TextureLayeredRD',
    TextureCubemapRD: 'TextureLayeredRD',
    TextureLayered: 'Texture',
    TextureLayeredRD: 'TextureLayered',
    Theme: 'Resource',
    TileMapPattern: 'Resource',
    TileSet: 'Resource',
    TileSetAtlasSource: 'TileSetSource',
    TileSetScenesCollectionSource: 'TileSetSource',
    TileSetSource: 'Resource',
    TorusMesh: 'PrimitiveMesh',
    Translation: 'Resource',
    TubeTrailMesh: 'PrimitiveMesh',
    VideoStream: 'Resource',
    VideoStreamPlayback: 'Resource',
    VideoStreamTheora: 'VideoStream',
    ViewportTexture: 'Texture2D',
    VisualShader: 'Shader',
    VisualShaderNode: 'Resource',
    VisualShaderNodeBillboard: 'VisualShaderNode',
    VisualShaderNodeBooleanConstant: 'VisualShaderNodeConstant',
    VisualShaderNodeBooleanParameter: 'VisualShaderNodeParameter',
    VisualShaderNodeClamp: 'VisualShaderNode',
    VisualShaderNodeColorConstant: 'VisualShaderNodeConstant',
    VisualShaderNodeColorFunc: 'VisualShaderNode',
    VisualShaderNodeColorOp: 'VisualShaderNode',
    VisualShaderNodeColorParameter: 'VisualShaderNodeParameter',
    VisualShaderNodeComment: 'VisualShaderNodeFrame',
    VisualShaderNodeCompare: 'VisualShaderNode',
    VisualShaderNodeConstant: 'VisualShaderNode',
    VisualShaderNodeCubemap: 'VisualShaderNode',
    VisualShaderNodeCubemapParameter: 'VisualShaderNodeTextureParameter',
    VisualShaderNodeCurveTexture: 'VisualShaderNodeResizableBase',
    VisualShaderNodeCurveXYZTexture: 'VisualShaderNodeResizableBase',
    VisualShaderNodeCustom: 'VisualShaderNode',
    VisualShaderNodeDerivativeFunc: 'VisualShaderNode',
    VisualShaderNodeDeterminant: 'VisualShaderNode',
    VisualShaderNodeDistanceFade: 'VisualShaderNode',
    VisualShaderNodeDotProduct: 'VisualShaderNode',
    VisualShaderNodeExpression: 'VisualShaderNodeGroupBase',
    VisualShaderNodeFaceForward: 'VisualShaderNodeVectorBase',
    VisualShaderNodeFloatConstant: 'VisualShaderNodeConstant',
    VisualShaderNodeFloatFunc: 'VisualShaderNode',
    VisualShaderNodeFloatOp: 'VisualShaderNode',
    VisualShaderNodeFloatParameter: 'VisualShaderNodeParameter',
    VisualShaderNodeFrame: 'VisualShaderNodeResizableBase',
    VisualShaderNodeFresnel: 'VisualShaderNode',
    VisualShaderNodeGlobalExpression: 'VisualShaderNodeExpression',
    VisualShaderNodeGroupBase: 'VisualShaderNodeResizableBase',
    VisualShaderNodeIf: 'VisualShaderNode',
    VisualShaderNodeInput: 'VisualShaderNode',
    VisualShaderNodeIntConstant: 'VisualShaderNodeConstant',
    VisualShaderNodeIntFunc: 'VisualShaderNode',
    VisualShaderNodeIntOp: 'VisualShaderNode',
    VisualShaderNodeIntParameter: 'VisualShaderNodeParameter',
    VisualShaderNodeIs: 'VisualShaderNode',
    VisualShaderNodeLinearSceneDepth: 'VisualShaderNode',
    VisualShaderNodeMix: 'VisualShaderNode',
    VisualShaderNodeMultiplyAdd: 'VisualShaderNode',
    VisualShaderNodeOuterProduct: 'VisualShaderNode',
    VisualShaderNodeOutput: 'VisualShaderNode',
    VisualShaderNodeParameter: 'VisualShaderNode',
    VisualShaderNodeParameterRef: 'VisualShaderNode',
    VisualShaderNodeParticleAccelerator: 'VisualShaderNode',
    VisualShaderNodeParticleBoxEmitter: 'VisualShaderNodeParticleEmitter',
    VisualShaderNodeParticleConeVelocity: 'VisualShaderNode',
    VisualShaderNodeParticleEmit: 'VisualShaderNode',
    VisualShaderNodeParticleEmitter: 'VisualShaderNode',
    VisualShaderNodeParticleMeshEmitter: 'VisualShaderNodeParticleEmitter',
    VisualShaderNodeParticleMultiplyByAxisAngle: 'VisualShaderNode',
    VisualShaderNodeParticleOutput: 'VisualShaderNodeOutput',
    VisualShaderNodeParticleRandomness: 'VisualShaderNode',
    VisualShaderNodeParticleRingEmitter: 'VisualShaderNodeParticleEmitter',
    VisualShaderNodeParticleSphereEmitter: 'VisualShaderNodeParticleEmitter',
    VisualShaderNodeProximityFade: 'VisualShaderNode',
    VisualShaderNodeRandomRange: 'VisualShaderNode',
    VisualShaderNodeRemap: 'VisualShaderNode',
    VisualShaderNodeReroute: 'VisualShaderNode',
    VisualShaderNodeResizableBase: 'VisualShaderNode',
    VisualShaderNodeRotationByAxis: 'VisualShaderNode',
    VisualShaderNodeSample3D: 'VisualShaderNode',
    VisualShaderNodeScreenNormalWorldSpace: 'VisualShaderNode',
    VisualShaderNodeScreenUVToSDF: 'VisualShaderNode',
    VisualShaderNodeSDFRaymarch: 'VisualShaderNode',
    VisualShaderNodeSDFToScreenUV: 'VisualShaderNode',
    VisualShaderNodeSmoothStep: 'VisualShaderNode',
    VisualShaderNodeStep: 'VisualShaderNode',
    VisualShaderNodeSwitch: 'VisualShaderNode',
    VisualShaderNodeTexture: 'VisualShaderNode',
    VisualShaderNodeTexture2DArray: 'VisualShaderNodeSample3D',
    VisualShaderNodeTexture2DArrayParameter: 'VisualShaderNodeTextureParameter',
    VisualShaderNodeTexture2DParameter: 'VisualShaderNodeTextureParameter',
    VisualShaderNodeTexture3D: 'VisualShaderNodeSample3D',
    VisualShaderNodeTexture3DParameter: 'VisualShaderNodeTextureParameter',
    VisualShaderNodeTextureParameter: 'VisualShaderNodeParameter',
    VisualShaderNodeTextureParameterTriplanar: 'VisualShaderNodeTextureParameter',
    VisualShaderNodeTextureSDF: 'VisualShaderNode',
    VisualShaderNodeTextureSDFNormal: 'VisualShaderNode',
    VisualShaderNodeTransformCompose: 'VisualShaderNode',
    VisualShaderNodeTransformConstant: 'VisualShaderNodeConstant',
    VisualShaderNodeTransformDecompose: 'VisualShaderNode',
    VisualShaderNodeTransformFunc: 'VisualShaderNode',
    VisualShaderNodeTransformOp: 'VisualShaderNode',
    VisualShaderNodeTransformParameter: 'VisualShaderNodeParameter',
    VisualShaderNodeTransformVecMult: 'VisualShaderNode',
    VisualShaderNodeUIntConstant: 'VisualShaderNodeConstant',
    VisualShaderNodeUIntFunc: 'VisualShaderNode',
    VisualShaderNodeUIntOp: 'VisualShaderNode',
    VisualShaderNodeUIntParameter: 'VisualShaderNodeParameter',
    VisualShaderNodeUVFunc: 'VisualShaderNode',
    VisualShaderNodeUVPolarCoord: 'VisualShaderNode',
    VisualShaderNodeVarying: 'VisualShaderNode',
    VisualShaderNodeVaryingGetter: 'VisualShaderNodeVarying',
    VisualShaderNodeVaryingSetter: 'VisualShaderNodeVarying',
    VisualShaderNodeVec2Constant: 'VisualShaderNodeConstant',
    VisualShaderNodeVec2Parameter: 'VisualShaderNodeParameter',
    VisualShaderNodeVec3Constant: 'VisualShaderNodeConstant',
    VisualShaderNodeVec3Parameter: 'VisualShaderNodeParameter',
    VisualShaderNodeVec4Constant: 'VisualShaderNodeConstant',
    VisualShaderNodeVec4Parameter: 'VisualShaderNodeParameter',
    VisualShaderNodeVectorBase: 'VisualShaderNode',
    VisualShaderNodeVectorCompose: 'VisualShaderNodeVectorBase',
    VisualShaderNodeVectorDecompose: 'VisualShaderNodeVectorBase',
    VisualShaderNodeVectorDistance: 'VisualShaderNodeVectorBase',
    VisualShaderNodeVectorFunc: 'VisualShaderNodeVectorBase',
    VisualShaderNodeVectorLen: 'VisualShaderNodeVectorBase',
    VisualShaderNodeVectorOp: 'VisualShaderNodeVectorBase',
    VisualShaderNodeVectorRefract: 'VisualShaderNodeVectorBase',
    VisualShaderNodeWorldPositionFromDepth: 'VisualShaderNode',
    VoxelGIData: 'Resource',
    World2D: 'Resource',
    World3D: 'Resource',
    WorldBoundaryShape2D: 'Shape2D',
    WorldBoundaryShape3D: 'Shape3D',
    X509Certificate: 'Resource',
});
//# sourceMappingURL=resourceBaseTypes.generated.js.map